import React from 'react';
import PropTypes from 'prop-types';
import moment from '@narvar/moment-shim';
import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import Container from './components/Container';
import Day from './components/Day';
import Weekday from './components/Weekday';
import Navbar from './components/Navbar';
import Caption from './components/Caption';

export { default as Container } from './components/Container';
export { default as Day } from './components/Day';
export { default as Weekday } from './components/Weekday';
export { default as Navbar } from './components/Navbar';
export { default as Caption } from './components/Caption';

export const onDayClick = (day, { selected, disabled }) => (selected || disabled ? null : day);

export const disabledDays =
  ({ include, exclude } = {}) =>
  (day) => {
    if (Array.isArray(include)) {
      for (let i = 0; i < include.length; i += 1) {
        if (moment(day).isSame(include[i], 'day')) return false;
      }

      return true;
    }

    if (Array.isArray(exclude)) {
      for (let i = 0; i < exclude.length; i += 1) {
        if (moment(day).isSame(exclude[i], 'day')) return true;
      }
    }

    return false;
  };

export const renderDay =
  (style = {}) =>
  // TODO: refactor this instead of disabling
  // eslint-disable-next-line react/display-name
  (day) => (
    <Day
      normalStyle={style.DayNormalStyle}
      disabledStyle={style.DayDisabledStyle}
      selectedStyle={style.DaySelectedStyle}
    >
      {day.getDate()}
    </Day>
  );

const Calendar = ({
  calendar,
  style,
  disableChangeMonth,
  formatWeekdayName,
  hideCaption,
  selectedDays,
  onDayClick: dayPickerOnDayClick,
  disabledDays: dayPickerDisabledDays,
  renderDay: dayPickerRenderDay,
  weekdayElement,
  navbarElement,
  captionElement,
  include,
  exclude,
}) => {
  const {
    Container: containerStyle,
    Weekday: weekdayStyle,
    Navbar: navbarStyle,
    Caption: captionStyle,
  } = style || {};

  return (
    <Container style={containerStyle}>
      <DayPicker
        selectedDays={selectedDays}
        onDayClick={dayPickerOnDayClick}
        disabledDays={dayPickerDisabledDays || disabledDays({ include, exclude })}
        renderDay={dayPickerRenderDay || renderDay(style)}
        weekdayElement={
          weekdayElement || <Weekday formatWeekdayName={formatWeekdayName} style={weekdayStyle} />
        }
        navbarElement={navbarElement || <Navbar style={navbarStyle} />}
        captionElement={
          captionElement || <Caption hideCaption={hideCaption} style={captionStyle} />
        }
        canChangeMonth={!disableChangeMonth}
        locale={moment.locale()}
        localeUtils={MomentLocaleUtils}
        {...calendar}
      />
    </Container>
  );
};

Calendar.defaultProps = {
  calendar: {},
  disableChangeMonth: false,
  formatWeekdayName: undefined,
  hideCaption: false,
  style: {},
  selectedDays: null,
  onDayClick: null,
  disabledDays: null,
  renderDay: null,
  weekdayElement: null,
  navbarElement: null,
  captionElement: null,
  include: null,
  exclude: null,
};

Calendar.propTypes = {
  calendar: PropTypes.shape(DayPicker.propTypes),
  disableChangeMonth: PropTypes.bool,
  formatWeekdayName: PropTypes.func,
  hideCaption: PropTypes.bool,
  style: PropTypes.shape({
    Container: Container.propTypes.style,
    DayNormalStyle: Day.propTypes.normalStyle,
    DayDisabledStyle: Day.propTypes.disabledStyle,
    DaySelectedStyle: Day.propTypes.selectedStyle,
    Weekday: Weekday.propTypes.style,
    Navbar: Navbar.propTypes.style,
    Caption: Caption.propTypes.style,
  }),
  include: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  exclude: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  selectedDays: PropTypes.func,
  onDayClick: PropTypes.func,
  disabledDays: PropTypes.func,
  renderDay: PropTypes.func,
  weekdayElement: PropTypes.node,
  navbarElement: PropTypes.node,
  captionElement: PropTypes.node,
};

export default Calendar;
